export const el = {
    common: {
        appName: 'WooConnect',
        loading: 'Φόρτωση...',
        save: 'Αποθήκευση',
        cancel: 'Ακύρωση',
        delete: 'Διαγραφή',
        edit: 'Επεξεργασία',
        create: 'Δημιουργία',
        search: 'Αναζήτηση',
        filter: 'Φίλτρο',
        refresh: 'Ανανέωση',
        retry: 'Δοκιμή ξανά',
        confirm: 'Επιβεβαίωση',
        back: 'Πίσω',
        next: 'Επόμενο',
        yes: 'Ναι',
        no: 'Όχι',
        all: 'Όλα',
        none: 'Κανένα',
        noResults: 'Δεν βρέθηκαν αποτελέσματα',
        error: 'Κάτι πήγε στραβά',
        success: 'Επιτυχία',
        required: 'Υποχρεωτικό',
        optional: 'Προαιρετικό',
        comingSoon: 'Έρχεται σύντομα',
        comingSoonDescription: 'Έρχεται στην επόμενη ενημέρωση',
        actions: 'Ενέργειες',
        view: 'Προβολή',
        close: 'Κλείσιμο',
        done: 'Τέλος',
        add: 'Προσθήκη',
        update: 'Ενημέρωση',
        enable: 'Ενεργοποίηση',
        disable: 'Απενεργοποίηση',
        active: 'Ενεργό',
        inactive: 'Ανενεργό',
        suspended: 'Σε αναστολή',
        showing: 'Εμφάνιση',
        of: 'από',
        perPage: 'ανά σελίδα',
        viewAll: 'Όλα',
        notFound: 'Η σελίδα δεν βρέθηκε',
        backToDashboard: 'Πίσω στον Πίνακα',
        selected: 'επιλεγμένα',
        noData: 'Δεν υπάρχουν δεδομένα',
        description: 'Περιγραφή',
        type: 'Τύπος',
        date: 'Ημερομηνία',
        amount: 'Ποσό',
        reason: 'Αιτία',
        details: 'Λεπτομέρειες',
        name: 'Όνομα',
        email: 'Email',
        phone: 'Τηλέφωνο',
        address: 'Διεύθυνση',
        company: 'Εταιρεία',
        status: 'Κατάσταση',
        role: 'Ρόλος',
        version: 'Έκδοση',
        features: 'Χαρακτηριστικά',
        slug: 'Slug',
        price: 'Τιμή',
        created: 'Δημιουργήθηκε',
        from: 'Από',
        to: 'Έως',
        expires: 'Λήγει',
        confirmDelete: 'Είστε σίγουροι ότι θέλετε να το διαγράψετε;',
        lastLogin: 'Τελευταία σύνδεση',
        remove: 'Αφαίρεση',
        assign: 'Ανάθεση',
        connect: 'Σύνδεση',
        disconnect: 'Αποσύνδεση',
        test: 'Δοκιμή',
    },
    auth: {
        login: 'Σύνδεση',
        logout: 'Αποσύνδεση',
        email: 'Email',
        password: 'Κωδικός',
        forgotPassword: 'Ξεχάσατε τον κωδικό;',
        resetPassword: 'Επαναφορά κωδικού',
        newPassword: 'Νέος κωδικός',
        confirmPassword: 'Επιβεβαίωση κωδικού',
        currentPassword: 'Τρέχων κωδικός',
        changePassword: 'Αλλαγή κωδικού',
        invalidCredentials: 'Λάθος email ή κωδικός',
        invalidEmail: 'Μη έγκυρη μορφή email',
        minPassword: 'Τουλάχιστον 8 χαρακτήρες',
        sessionExpired: 'Η συνεδρία έληξε. Συνδεθείτε ξανά.',
    },
    nav: {
        dashboard: 'Πίνακας',
        orders: 'Παραγγελίες',
        products: 'Προϊόντα',
        customers: 'Πελάτες',
        analytics: 'Αναλυτικά',
        notifications: 'Ειδοποιήσεις',
        settings: 'Ρυθμίσεις',
        users: 'Χρήστες',
        subscriptions: 'Συνδρομές',
        plugins: 'Plugins',
        ai: 'AI',
        auditLog: 'Ιστορικό',
        systemSettings: 'Ρυθμίσεις Συστήματος',
        apiDocs: 'Τεκμηρίωση API',
        marketing: 'Μάρκετινγκ',
        roleDefaults: 'Ρόλοι',
    },
    dashboard: {
        title: 'Πίνακας',
        ordersToday: 'Παραγγελίες σήμερα',
        revenueToday: 'Έσοδα σήμερα',
        revenueWeek: 'Έσοδα εβδομάδας',
        revenueMonth: 'Έσοδα μήνα',
        totalProducts: 'Σύνολο προϊόντων',
        totalCustomers: 'Σύνολο πελατών',
        recentOrders: 'Πρόσφατες παραγγελίες',
        selectStore: 'Επιλογή καταστήματος',
        pending: 'Σε εκκρεμότητα',
        processing: 'Σε επεξεργασία',
        thisWeek: 'Αυτή τη βδομάδα',
        revenueChart: 'Έσοδα',
        lowStockAlert: 'Απόθεμα',
        lowStockDesc: '{{low}} χαμηλό απόθεμα, {{out}} εξαντλημένα',
        loadTimeout: 'Δεν ήταν δυνατή η φόρτωση. Ελέγξτε τη σύνδεσή σας.',
    },
    orders: {
        title: 'Παραγγελίες',
        order: 'Παραγγελία',
        status: 'Κατάσταση',
        customer: 'Πελάτης',
        total: 'Σύνολο',
        date: 'Ημερομηνία',
        items: 'Προϊόντα',
        notes: 'Σημειώσεις',
        addNote: 'Προσθήκη σημείωσης',
        addNotePlaceholder: 'Γράψτε μια σημείωση...',
        changeStatus: 'Αλλαγή κατάστασης',
        refund: 'Επιστροφή χρημάτων',
        refundAmount: 'Ποσό επιστροφής',
        refundReason: 'Αιτία επιστροφής',
        bulkUpdate: 'Μαζική ενημέρωση',
        noOrders: 'Δεν υπάρχουν παραγγελίες',
        noNotes: 'Δεν υπάρχουν σημειώσεις',
        showSystemNotes: 'Εμφάνιση τεχνικών σημειώσεων',
        hideSystemNotes: 'Απόκρυψη τεχνικών σημειώσεων',
        subtotal: 'Μερικό σύνολο',
        shipping: 'Αποστολή',
        tax: 'Φόρος',
        discount: 'Έκπτωση',
        payment: 'Πληρωμή',
        billing: 'Τιμολόγηση',
        billingAddress: 'Διεύθυνση χρέωσης',
        shippingAddress: 'Διεύθυνση αποστολής',
        sendToCustomer: 'Αποστολή στον πελάτη',
        customerNote: 'Σημείωση πελάτη',
        transactionId: 'Κωδικός συναλλαγής',
        fees: 'Χρεώσεις',
        refundsTitle: 'Επιστροφές',
        dateCompleted: 'Ολοκληρώθηκε',
        each: '/τεμ.',
        datePaid: 'Ημ. πληρωμής',
        confirmStatusChange: 'Αλλαγή παραγγελίας {{orderNumber}} σε "{{status}}";',
        bulkConfirmStatusChange: 'Αλλαγή {{count}} παραγγελιών σε "{{status}}";',
        coupon: 'Κουπόνι',
        statuses: {
            pending: 'Σε αναμονή',
            processing: 'Σε επεξεργασία',
            'on-hold': 'Σε αναστολή',
            completed: 'Ολοκληρωμένη',
            cancelled: 'Ακυρωμένη',
            refunded: 'Επιστράφηκε',
            failed: 'Αποτυχημένη',
        },
    },
    products: {
        title: 'Προϊόντα',
        name: 'Όνομα',
        price: 'Τιμή',
        regularPrice: 'Κανονική τιμή',
        salePrice: 'Τιμή προσφοράς',
        stock: 'Απόθεμα',
        stockQuantity: 'Ποσότητα αποθέματος',
        manageStock: 'Διαχείριση αποθέματος',
        lowStockThreshold: 'Όριο χαμηλού αποθέματος',
        category: 'Κατηγορία',
        categories: 'Κατηγορίες',
        tags: 'Ετικέτες',
        status: 'Κατάσταση',
        lowStock: 'Χαμηλό απόθεμα',
        outOfStock: 'Εξαντλημένο',
        inStock: 'Διαθέσιμο',
        noProducts: 'Δεν υπάρχουν προϊόντα',
        sku: 'SKU',
        published: 'Δημοσιευμένο',
        draft: 'Πρόχειρο',
        simple: 'Απλό',
        variable: 'Μεταβλητό',
        quickEdit: 'Γρήγορη επεξεργασία',
        salePriceMustBeLower: 'Η τιμή προσφοράς πρέπει να είναι χαμηλότερη από την κανονική τιμή',
        stockCannotBeNegative: 'Η ποσότητα αποθέματος δεν μπορεί να είναι αρνητική',
        leaveEmptyToRemoveSale: 'Αφήστε κενό για κατάργηση προσφοράς',
        images: 'Εικόνες',
        description: 'Περιγραφή',
        productInfo: 'Πληροφορίες προϊόντος',
        pricing: 'Τιμολόγηση',
        inventory: 'Απόθεμα',
        stockStatus: 'Κατάσταση αποθέματος',
        productType: 'Τύπος προϊόντος',
        totalSales: 'Συνολικές πωλήσεις',
    },
    customers: {
        title: 'Πελάτες',
        name: 'Όνομα',
        email: 'Email',
        totalSpent: 'Σύνολο αγορών',
        ordersCount: 'Παραγγελίες',
        lastOrder: 'Τελευταία παραγγελία',
        noCustomers: 'Δεν υπάρχουν πελάτες',
        segment: 'Κατηγορία',
        customerSince: 'Πελάτης από',
        averageOrder: 'Μέση αξία παραγγελίας',
        recentOrders: 'Πρόσφατες παραγγελίες',
        profile: 'Προφίλ',
        billingAddress: 'Διεύθυνση χρέωσης',
        shippingAddress: 'Διεύθυνση αποστολής',
        stats: 'Στατιστικά',
        syncNote: 'Τα στατιστικά πελατών (παραγγελίες, δαπάνες) μπορεί να χρειάζονται συγχρονισμό στο WooCommerce Analytics.',
        segments: {
            vip: 'VIP',
            repeat: 'Επαναλαμβανόμενος',
            new: 'Νέος',
            inactive: 'Ανενεργός',
        },
    },
    analytics: {
        attribution: 'Πηγές',
        attributionRate: 'Ποσοστό πηγών',
        topSource: 'Κορυφαία πηγή',
        topCampaign: 'Κορυφαίο campaign',
        mobileShare: 'Ποσοστό mobile',
        sourceConversion: 'Πηγή → Πωλήσεις',
        source: 'Πηγή',
        campaigns: 'Campaigns',
        devices: 'Συσκευές',
        attributionUnavailable: 'Μη διαθέσιμο',
        attributionNeedsBridge: 'Το attribution απαιτεί το WooConnect Bridge στο store.',
        attributionCoverageNote: 'Μόνο {{pct}}% των παραγγελιών έχουν δεδομένα πηγής· τα υπόλοιπα ως Direct/Untracked.',
        title: 'Αναλυτικά',
        revenueThisMonth: 'Έσοδα αυτό τον μήνα',
        ordersThisMonth: 'Παραγγελίες αυτό τον μήνα',
        averageOrderValue: 'Μέση αξία παραγγελίας',
        newCustomers: 'Νέοι πελάτες',
        revenue: 'Έσοδα',
        topSellers: 'Κορυφαία προϊόντα',
        sales: 'Πωλήσεις',
        statusBreakdown: 'Ανάλυση καταστάσεων',
        customerAnalytics: 'Αναλυτικά πελατών',
        period: 'Περίοδος',
        daily: 'Ημερήσια',
        weekly: 'Εβδομαδιαία',
        monthly: 'Μηνιαία',
        days7: '7 ημέρες',
        days14: '14 ημέρες',
        days30: '30 ημέρες',
        days90: '90 ημέρες',
        advancedAnalytics: 'Αναλυτικά Pro',
        advancedDescription: 'Προχωρημένη ανάλυση πελατών, τάσεις εσόδων και πολλά άλλα.',
        learnMore: 'Μάθετε περισσότερα',
        viewAnalytics: 'Αναλυτικά',
        sold: 'πωλήθηκαν',
        noTopSellers: 'Δεν υπάρχουν δεδομένα πωλήσεων',
        trend: 'Τάση',
        days365: '1 Έτος',
        revenueComparison: 'Σύγκριση εσόδων',
        currentPeriod: 'Τρέχουσα περίοδος',
        previousPeriod: 'Προηγούμενη περίοδος',
        metric: 'Μέτρηση',
        change: 'Μεταβολή',
        paymentMethods: 'Τρόποι πληρωμής',
        noPaymentData: 'Δεν υπάρχουν δεδομένα πληρωμών',
        orders: 'Παραγγελίες',
        customerStats: 'Επισκόπηση πελατών',
        totalCustomers: 'Σύνολο πελατών',
        newThisMonth: 'Νέοι αυτό τον μήνα',
        newLastMonth: 'Νέοι τον προηγ. μήνα',
        topCustomersBySpend: 'Top πελάτες κατά αγορές',
        noCustomerData: 'Δεν υπάρχουν δεδομένα πελατών',
        lowStockAlerts: 'Ειδοποιήσεις αποθέματος',
        lowStockItems: '{{count}} προϊόντα με χαμηλό απόθεμα',
        outOfStockItems: '{{count}} προϊόντα εξαντλημένα',
        viewProducts: 'Προβολή προϊόντων',
        image: 'Εικόνα',
        product: 'Προϊόν',
        totalOrders: 'Σύνολο παραγγελιών',
        vsLastMonth: 'σε σχέση με τον προηγ. μήνα',
        // Tab labels
        overview: 'Επισκόπηση',
        products: 'Προϊόντα',
        customers: 'Πελάτες',
        stock: 'Απόθεμα',
        coupons: 'Κουπόνια',
        taxes: 'Φόροι',
        // Date range
        dateRange: 'Χρονικό διάστημα',
        compareTo: 'Σύγκριση με',
        previousYear: 'Προηγούμενο έτος',
        today: 'Σήμερα',
        yesterday: 'Χθες',
        last7days: 'Τελευταίες 7 ημέρες',
        last30days: 'Τελευταίες 30 ημέρες',
        thisMonth: 'Αυτό τον μήνα',
        lastMonth: 'Προηγούμενος μήνας',
        thisQuarter: 'Αυτό το τρίμηνο',
        thisYear: 'Αυτό το έτος',
        customRange: 'Προσαρμοσμένο διάστημα',
        // Revenue metrics
        grossSales: 'Ακαθάριστες πωλήσεις',
        netRevenue: 'Καθαρά έσοδα',
        ordersCount: 'Παραγγελίες',
        productsSold: 'Προϊόντα πωληθέντα',
        insightBestDay: 'Καλύτερη μέρα',
        insightConcentration: 'Τα top 3 προϊόντα φέρνουν',
        insightAov: 'Μέση αξία παραγγελίας',
        unitsShort: 'τεμ.',
        netExclVat: 'Καθαρά έσοδα · χωρίς ΦΠΑ',
        alertAovDrop: 'Η μέση αξία παραγγελίας έπεσε {{value}}% σε σχέση με την προηγούμενη περίοδο',
        alertRevenueDrop: 'Τα καθαρά έσοδα έπεσαν {{value}}% σε σχέση με την προηγούμενη περίοδο',
        alertHighRefunds: 'Το ποσοστό επιστροφών είναι {{value}}%',
        alertLowAttribution: 'Μόνο το {{value}}% των παραγγελιών έχει δεδομένα προέλευσης',
        itemsSold: 'Τεμάχια πωληθέντα',
        avgOrderValue: 'Μέση αξία παραγγελίας',
        avgItemsPerOrder: 'Μέσα τεμάχια/παραγγελία',
        couponsUsed: 'Κουπόνια χρησιμοποιημένα',
        couponsAmount: 'Ποσό κουπονιών',
        shippingTotal: 'Αποστολή',
        taxesTotal: 'Φόροι',
        refundsTotal: 'Επιστροφές',
        vsLastPeriod: 'σε σχέση με προηγ. περίοδο',
        // Order Intelligence / Profit (Wave 2)
        profitMargin: 'Κέρδος & Περιθώριο',
        grossProfit: 'Μικτό κέρδος',
        margin: 'Περιθώριο',
        cogs: 'Κόστος πωληθέντων',
        costCoverage: 'Κάλυψη κόστους',
        costCoverageHint: 'των εσόδων έχει δεδομένα κόστους',
        noCostData: 'Χωρίς δεδομένα κόστους',
        noCostDataHint: 'Πρόσθεσε κόστος στα προϊόντα σου για να δεις κέρδος και περιθώριο.',
        refunds: 'Επιστροφές',
        refundRate: 'Ποσοστό επιστροφών',
        refundsCount: 'Επιστροφές',
        avgRefund: 'Μέση επιστροφή',
        avg: 'μέσος όρος',
        orderValueDistribution: 'Κατανομή αξίας παραγγελιών',
        topCustomersHint: 'Συνολικές δαπάνες · πελάτες ενεργοί σε αυτή την περίοδο',
        // Customer Intelligence (Wave 3)
        customerIntel: 'Ανάλυση Πελατών',
        returningCustomers: 'Επαναλαμβανόμενοι',
        repeatRate: 'Ποσοστό επανάληψης',
        avgLifetimeValue: 'Μέση αξία ζωής',
        ordersPerCustomer: 'παραγγελίες/πελάτη',
        topCustomersPeriod: 'Κορυφαίοι πελάτες (περιόδου)',
        periodSpend: 'Δαπάνη περιόδου',
        rfmSegments: 'Τμήματα πελατών (RFM)',
        topCities: 'Κορυφαίες πόλεις',
        stockValue: 'Αξία αποθέματος',
        discountOfGross: '% επί μικτών',
        browsers: 'Browsers',
        customersBySource: 'Πελάτες ανά πηγή',
        landingPages: 'Σελίδες εισόδου',
        cohorts: 'Διατήρηση κοόρτης',
        cohortsHint: '% κάθε μήνα απόκτησης που ξαναπαρήγγειλε',
        stockVelocity: 'Τελειώνουν σύντομα',
        daysLeft: 'ημέρες',
        inStockShort: 'σε απόθεμα',
        alerts: 'Ειδοποιήσεις',
        platinum: 'Platinum',
        gold: 'Gold',
        silver: 'Silver',
        bronze: 'Bronze',
        avgDaysBetween: 'Μέσες ημέρες μεταξύ παραγγελιών',
        avgRecency: 'Μέση πρόσφατη',
        lifetimeShort: 'σύνολο',
        // Product Intelligence (Wave 4)
        topVariations: 'Κορυφαίες παραλλαγές',
        frequentlyBoughtTogether: 'Αγοράζονται συχνά μαζί',
        // Sales Patterns (Wave 5)
        salesByDay: 'Πωλήσεις ανά ημέρα',
        peakHours: 'Ώρες αιχμής',
        shippingMethods: 'Τρόποι αποστολής',
        byCountry: 'Ανά χώρα',
        // Abandoned Cart Recovery (Wave 6)
        abandonedCarts: 'Ανάκτηση εγκαταλειμμένων καλαθιών',
        cartsCaptured: 'Καλάθια που καταγράφηκαν',
        recovered: 'ανακτήθηκαν',
        recoveredValue: 'Αξία που ανακτήθηκε',
        lostValue: 'Χαμένη αξία',
        // Compare (Wave 7)
        compareTitle: 'Σύγκριση περιόδων',
        current: 'Τρέχουσα',
        // Products tab
        topProducts: 'Κορυφαία προϊόντα',
        productName: 'Προϊόν',
        unitsSold: 'Τεμάχια πωληθέντα',
        categoryBreakdown: 'Ανάλυση κατηγοριών',
        category: 'Κατηγορία',
        productsCount: 'Προϊόντα',
        revenueByCategory: 'Έσοδα ανά κατηγορία',
        noProductData: 'Δεν υπάρχουν δεδομένα προϊόντων για αυτή την περίοδο',
        // Orders tab
        orderStatus: 'Κατάσταση παραγγελίας',
        netSales: 'Καθαρές πωλήσεις',
        avgItems: 'Μέσα τεμάχια',
        ordersByDay: 'Παραγγελίες σε βάθος χρόνου',
        statusBreakdownTitle: 'Ανάλυση καταστάσεων',
        paymentMethodsTitle: 'Τρόποι πληρωμής',
        // Customers tab
        totalCustomersCount: 'Σύνολο πελατών',
        avgOrders: 'Μέσες παραγγελίες',
        avgSpend: 'Μέση δαπάνη',
        topCustomersTitle: 'Κορυφαίοι πελάτες',
        totalSpent: 'Σύνολο αγορών',
        lastActive: 'Τελευταία δραστηριότητα',
        customersByLocation: 'Πελάτες ανά τοποθεσία',
        noCustomers: 'Δεν υπάρχουν δεδομένα πελατών για αυτή την περίοδο',
        // Stock tab
        stockSummary: 'Σύνοψη αποθέματος',
        inStock: 'Σε απόθεμα',
        lowStockLabel: 'Χαμηλό απόθεμα',
        outOfStockLabel: 'Εξαντλημένο',
        onBackorder: 'Σε παραγγελία',
        lowStockProducts: 'Προϊόντα με χαμηλό απόθεμα',
        stockStatus: 'Κατάσταση',
        quantity: 'Ποσότητα',
        noStockData: 'Δεν υπάρχουν δεδομένα αποθέματος',
        // Coupons tab
        topCoupons: 'Κορυφαία κουπόνια',
        couponCode: 'Κωδικός κουπονιού',
        discount: 'Έκπτωση',
        couponsOverTime: 'Κουπόνια σε βάθος χρόνου',
        totalDiscount: 'Συνολική έκπτωση',
        ordersWithCoupons: 'Παραγγελίες με κουπόνια',
        noCouponData: 'Δεν υπάρχουν δεδομένα κουπονιών για αυτή την περίοδο',
        // Taxes tab
        taxRates: 'Φορολογικοί συντελεστές',
        taxRate: 'Συντελεστής',
        orderTax: 'Φόρος παραγγελίας',
        shippingTax: 'Φόρος αποστολής',
        totalTax: 'Συνολικός φόρος',
        noTaxData: 'Δεν υπάρχουν φορολογικά δεδομένα για αυτή την περίοδο',
        // Compare
        compare: 'Σύγκριση',
        difference: 'Διαφορά',
        thisPeriod: 'Αυτή η περίοδος',
        fullAnalyticsInPanel: 'Πλήρη αναλυτικά στο Panel',
        // VAT
        inclVat: '(με ΦΠΑ)',
        exclVat: '(χωρίς ΦΠΑ)',
        // Status filter
        statusFilter: 'Καταστάσεις παραγγελιών',
        allStatuses: 'Όλες οι καταστάσεις',
        // Settings tab
        settings: 'Ρυθμίσεις',
        settingsTitle: 'Ρυθμίσεις Αναλυτικών',
        dateDisplay: 'Ημερομηνία & Εμφάνιση',
        defaultPreset: 'Προεπιλεγμένη Περίοδος',
        dateColumnLabel: 'Στήλη Ημερομηνίας',
        dateCreated: 'Δημιουργία Παραγγελίας',
        datePaid: 'Πληρωμή Παραγγελίας',
        dateCompleted: 'Ολοκλήρωση Παραγγελίας',
        weekStartsOn: 'Η Εβδομάδα Ξεκινά',
        monday: 'Δευτέρα',
        sunday: 'Κυριακή',
        // Order status settings
        orderStatusesTitle: 'Καταστάσεις Παραγγελιών',
        paidStatusesHelp: 'Ποιες καταστάσεις μετρούν ως ΠΛΗΡΩΜΕΝΕΣ στα έσοδα και τις πωλήσεις. Από προεπιλογή είναι επιλεγμένες μόνο «Σε επεξεργασία» και «Ολοκληρωμένη».',
        syncedFromWc: 'Συγχρονισμένο από WooCommerce: {{count}} καταστάσεις ({{custom}} προσαρμοσμένες)',
        syncFromStore: 'Συγχρονισμός από Κατάστημα',
        syncing: 'Συγχρονισμός...',
        syncSuccess: 'Ρυθμίσεις συγχρονίστηκαν από το κατάστημα',
        customStatus: 'Προσαρμοσμένη',
        defaultStatus: 'Προεπιλογή',
        paid: 'Πληρωμένη',
        unpaid: 'Απλήρωτη',
        // Store info
        storeInfo: 'Πληροφορίες Καταστήματος',
        taxesEnabledLabel: 'Φόροι',
        hposEnabledLabel: 'HPOS',
        enabled: 'Ενεργοποιημένο',
        disabled: 'Απενεργοποιημένο',
        lastSynced: 'Τελευταίος Συγχρονισμός',
        never: 'Ποτέ',
        settingsSaved: 'Οι ρυθμίσεις αναλυτικών αποθηκεύτηκαν',
        // New presets
        last14days: 'Τελευταίες 14 ημέρες',
        last90days: 'Τελευταίες 90 ημέρες',
        last365days: 'Τελευταίες 365 ημέρες',
        thisWeek: 'Αυτή την Εβδομάδα',
        lastWeek: 'Προηγούμενη Εβδομάδα',
        // Compare tab
        compareDefaultPreset: 'Προεπιλεγμένη Σύγκριση',
        periodA: 'Περίοδος Α',
        periodB: 'Περίοδος Β',
        customDates: 'Προσαρμοσμένες Ημ/νίες',
        customFrom: 'Από',
        customTo: 'Έως',
        selectDate: 'Επιλέξτε ημ/νία',
        // Tab extras
        noOrderData: 'Δεν υπάρχουν δεδομένα παραγγελιών',
        compareMode: 'Σύγκριση',
        filterByStatus: 'Φίλτρο κατάστασης',
        location: 'Τοποθεσία',
        stockProducts: 'Προϊόντα',
        rate: 'Συντελεστής',
        // General
        noData: 'Δεν υπάρχουν δεδομένα για αυτή την περίοδο',
        loading: 'Φόρτωση αναλυτικών...',
        couponsTotal: 'Σύνολο Κουπονιών',
        timezone: 'Ζώνη ώρας',
    },
    notifications: {
        title: 'Ειδοποιήσεις',
        markRead: 'Σήμανση ως αναγνωσμένο',
        markAllRead: 'Ανάγνωση όλων',
        noNotifications: 'Δεν υπάρχουν ειδοποιήσεις',
        preferences: 'Προτιμήσεις ειδοποιήσεων',
        unread: 'Μη αναγνωσμένα',
        orderNotifications: 'Παραγγελίες',
        stockNotifications: 'Απόθεμα',
        systemNotifications: 'Σύστημα',
        newOrder: 'Νέα παραγγελία',
        viewAll: 'Όλες',
        statusChanges: 'Αλλαγές κατάστασης',
        lowStock: 'Χαμηλό απόθεμα',
        lowStockAlerts: 'Χαμηλό απόθεμα',
        refundAlerts: 'Επιστροφές',
        backorderAlerts: 'Παραγγελίες σε αναμονή',
        dailySummary: 'Ημερήσια περίληψη',
        prefsSaved: 'Οι προτιμήσεις αποθηκεύτηκαν',
        prefsDescription: 'Επιλέξτε ποιες ειδοποιήσεις θέλετε να λαμβάνετε για αυτό το κατάστημα.',
        orderStatusChanged: 'Αλλαγές κατάστασης παραγγελιών',
        refundRequest: 'Αιτήματα επιστροφής',
        productBackorder: 'Προϊόντα σε αναμονή',
        deleteAll: 'Διαγραφή όλων',
        confirmDeleteAll: 'Διαγραφή όλων των ειδοποιήσεων;',
        allDeleted: 'Όλες οι ειδοποιήσεις διαγράφηκαν',
        allStores: 'Όλα τα καταστήματα',
        tpl: {
            newOrderTitle: 'Νέα Παραγγελία #{{number}}',
            newOrderBody: 'Ο/Η {{name}} έκανε παραγγελία {{currency}} {{total}}',
            statusChangedTitle: 'Παραγγελία #{{number}} Ενημερώθηκε',
            statusChangedBody: 'Αλλαγή κατάστασης από {{oldStatus}} σε {{newStatus}}',
            lowStockTitle: 'Χαμηλό Απόθεμα: {{product}}',
            lowStockBody: 'Μόνο {{quantity}} τεμάχια απομένουν (SKU: {{sku}})',
            refundTitle: 'Επιστροφή Παραγγελίας #{{orderId}}',
            refundBody: '{{amount}} επιστράφηκε. Αιτία: {{reason}}',
            backorderTitle: 'Σε Αναμονή: {{product}}',
            backorderBody: 'Το {{product}} είναι σε αναμονή (SKU: {{sku}})',
        },
    },
    settings: {
        title: 'Ρυθμίσεις',
        profile: 'Προφίλ',
        stores: 'Συνδεδεμένα καταστήματα',
        appearance: 'Εμφάνιση',
        language: 'Γλώσσα',
        theme: 'Θέμα',
        integrations: 'Ενσωματώσεις',
        about: 'Σχετικά',
        notificationPrefs: 'Ειδοποιήσεις',
        themeLight: 'Φωτεινό',
        themeDark: 'Σκοτεινό',
        themeSystem: 'Σύστημα',
        dateFormat: 'Μορφή ημερομηνίας',
        itemsPerPage: 'Αντικείμενα ανά σελίδα',
        emailReadOnly: 'Επικοινωνήστε με τον διαχειριστή για αλλαγή email',
        firstName: 'Όνομα',
        lastName: 'Επώνυμο',
        avatarUrl: 'URL φωτογραφίας',
        storeUrl: 'URL καταστήματος',
        wcKey: 'Κλειδί WooCommerce',
        wcSecret: 'Μυστικό WooCommerce',
        bridgeKey: 'Κλειδί Bridge',
        storeName: 'Όνομα καταστήματος',
        account: 'Λογαριασμός',
        session: 'Συνεδρία',
        security: 'Ασφάλεια',
        biometricLogin: 'Βιομετρική σύνδεση',
        editProfile: 'Επεξεργασία προφίλ',
        confirmLogout: 'Αποσύνδεση από WooConnect;',
        confirmLogoutMessage: 'Θα πρέπει να συνδεθείτε ξανά για να δείτε τα καταστήματά σας.',
        support: 'Υποστήριξη',
        preferences: 'Προτιμήσεις',
        passwordMinLength: 'Ο κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες',
        passwordsMustMatch: 'Οι κωδικοί πρέπει να ταιριάζουν',
        passwordChanged: 'Ο κωδικός άλλαξε',
        profileSaved: 'Το προφίλ αποθηκεύτηκε',
    },
    sites: {
        title: 'Καταστήματα',
        addStore: 'Σύνδεση καταστήματος',
        testConnection: 'Έλεγχος σύνδεσης',
        disconnect: 'Αποσύνδεση',
        health: 'Υγεία',
        online: 'Online',
        offline: 'Offline',
        noSites: 'Δεν υπάρχουν συνδεδεμένα καταστήματα',
        editStore: 'Επεξεργασία καταστήματος',
        confirmDisconnect: 'Αυτό θα αφαιρέσει τη πρόσβαση για όλους τους χρήστες αυτού του καταστήματος. Είστε σίγουροι;',
        connectionSuccess: 'Το κατάστημα συνδέθηκε',
        connectionFailed: 'Η σύνδεση απέτυχε',
        testSuccess: 'Η δοκιμή σύνδεσης πέτυχε',
        testFailed: 'Η δοκιμή σύνδεσης απέτυχε',
        wcConnected: 'WooCommerce: Συνδεδεμένο',
        wcFailed: 'WooCommerce: Αποτυχία',
        bridgeConnected: 'Bridge: Συνδεδεμένο',
        bridgeFailed: 'Bridge: Μη συνδεδεμένο',
        bridgeNotInstalled: 'Bridge: Μη εγκατεστημένο',
        currency: 'Νόμισμα',
        timezone: 'Ζώνη ώρας',
        connectedSince: 'Συνδεδεμένο',
        wcVersion: 'Έκδοση WC',
        wpVersion: 'Έκδοση WP',
        bridgeVersion: 'Έκδοση Bridge',
        bridgeLabel: 'Bridge {{version}}',
        urlMustBeHttps: 'Το URL πρέπει να ξεκινά με https://',
        invalidWcKey: 'Πρέπει να ξεκινά με ck_',
        invalidWcSecret: 'Πρέπει να ξεκινά με cs_',
    },
    subscription: {
        title: 'Συνδρομή',
        plan: 'Πλάνο',
        status: 'Κατάσταση',
        expiresAt: 'Λήγει',
        extend: 'Παράταση',
        changePlan: 'Αλλαγή πλάνου',
        maxSites: 'Μέγ. καταστήματα',
        priceAmount: 'Τιμή',
        plans: {
            free_trial: 'Δωρεάν δοκιμή',
            monthly: 'Μηνιαία',
            yearly: 'Ετήσια',
            lifetime: 'Δια βίου',
            custom: 'Προσαρμοσμένη',
        },
        statuses: {
            trial: 'Δοκιμαστική',
            active: 'Ενεργή',
            expired: 'Ληγμένη',
            cancelled: 'Ακυρωμένη',
            expiring_soon: 'Λήγει σύντομα',
            grace_period: 'Περίοδος χάριτος',
        },
    },
    plugins: {
        title: 'Plugins',
        installed: 'Εγκατεστημένο',
        notInstalled: 'Μη εγκατεστημένο',
        required: 'Απαιτείται',
        getPlugin: 'Απόκτηση plugin',
        notifyAdmin: 'Αίτηση plugin',
        addPlugin: 'Προσθήκη plugin',
        noPlugins: 'Δεν υπάρχουν plugins',
        bridgeTitle: 'WooConnect Bridge Plugin',
        bridgeDescription: 'Απαιτούμενο WordPress plugin που συνδέει το WooCommerce κατάστημά σας με την πλατφόρμα WooConnect. Εγκαταστήστε το σε κάθε κατάστημα που θέλετε να διαχειριστείτε.',
        installGuide: 'Οδηγός Εγκατάστασης',
        step1: 'Κατεβάστε το ZIP αρχείο με το παρακάτω κουμπί',
        step2: 'Στο WordPress, πηγαίνετε στο Plugins > Add New > Upload Plugin',
        step3: 'Ανεβάστε το ZIP αρχείο και πατήστε Install Now',
        step4: 'Ενεργοποιήστε το plugin και εισάγετε το Bridge API Key από τις ρυθμίσεις του καταστήματος',
        downloadBridge: 'Λήψη Plugin',
        bridgeVersion: 'Έκδοση',
        bridgeRequirements: 'Απαιτήσεις',
        bridgeRequiresWP: 'WordPress {{version}}+',
        bridgeRequiresPHP: 'PHP {{version}}+',
        bridgeRequiresWC: 'WooCommerce {{min}}+ (δοκιμασμένο έως {{max}})',
        bridgeWhatsNew: 'Τι νέο',
        copySteps: 'Αντιγραφή βημάτων',
        copied: 'Αντιγράφηκε',
        installSteps: '1. Κατεβάστε το ZIP αρχείο\n2. Στο WordPress: Plugins > Add New > Upload Plugin\n3. Ανεβάστε το ZIP και πατήστε Install Now\n4. Ενεργοποιήστε και εισάγετε το Bridge API Key από τις ρυθμίσεις',
    },
    ai: {
        title: 'AI Βοηθός',
        chat: 'Συνομιλία',
        composeEmail: 'Σύνταξη email',
        businessProfile: 'Προφίλ επιχείρησης',
        usage: 'Χρήση AI',
        totalCost: 'Συνολικό κόστος αυτό τον μήνα',
        requestsByFeature: 'Αιτήματα ανά λειτουργία',
        costByUser: 'Κόστος ανά χρήστη',
        aiEnabled: 'AI ενεργοποιημένο',
        defaultModel: 'Προεπιλεγμένο μοντέλο',
        maxTokens: 'Μέγ. tokens',
        usageLimits: 'Όρια χρήσης',
        requests: 'Αιτήματα',
        cost: 'Κόστος',
        totalRequests: 'Συνολικά αιτήματα',
        features: 'λειτουργίες',
    },
    admin: {
        title: 'Διαχείριση',
        users: 'Χρήστες',
        createUser: 'Δημιουργία χρήστη',
        editUser: 'Επεξεργασία χρήστη',
        resetPassword: 'Επαναφορά κωδικού',
        changeStatus: 'Αλλαγή κατάστασης',
        userDetail: 'Στοιχεία χρήστη',
        noUsers: 'Δεν βρέθηκαν χρήστες',
        subscriptions: 'Συνδρομές',
        extendSubscription: 'Παράταση συνδρομής',
        days30: '+30 Ημέρες',
        days90: '+90 Ημέρες',
        year1: '+1 Έτος',
        custom: 'Προσαρμοσμένο',
        noSubscriptions: 'Δεν βρέθηκαν συνδρομές',
        auditLog: 'Ιστορικό',
        noAuditLogs: 'Δεν βρέθηκαν εγγραφές',
        action: 'Ενέργεια',
        user: 'Χρήστης',
        site: 'Κατάστημα',
        time: 'Ώρα',
        ipAddress: 'Διεύθυνση IP',
        settings: 'Ρυθμίσεις εφαρμογής',
        settingKey: 'Κλειδί',
        settingValue: 'Τιμή',
        editSetting: 'Επεξεργασία ρύθμισης',
        expiringWithin: 'Λήγουν εντός',
        days: 'ημερών',
        plugins: 'Plugins',
        addPlugin: 'Προσθήκη Plugin',
        noPlugins: 'Δεν υπάρχουν plugins',
        appSettings: 'Ρυθμίσεις εφαρμογής',
        section: 'Διαχείριση',
        deleteUser: 'Διαγραφή χρήστη',
        confirmDeleteUser: 'Αυτό θα απενεργοποιήσει τον χρήστη και θα ανακαλέσει όλες τις συνεδρίες. Είστε σίγουροι;',
        resetPasswordDesc: 'Ορισμός νέου κωδικού για αυτόν τον χρήστη. Θα αποσυνδεθεί από όλες τις συνεδρίες.',
        assignStore: 'Ανάθεση καταστήματος',
        unassignStore: 'Αφαίρεση καταστήματος',
        confirmUnassignStore: 'Αυτό θα αφαιρέσει τη πρόσβαση στο κατάστημα για αυτόν τον χρήστη. Είστε σίγουροι;',
        editPermissions: 'Επεξεργασία δικαιωμάτων',
        permissions: 'Δικαιώματα',
        assignedStores: 'Ανατεθειμένα καταστήματα',
        noAssignedStores: 'Δεν υπάρχουν καταστήματα για αυτόν τον χρήστη',
        allStoresAssigned: 'Όλα τα καταστήματα έχουν ήδη ανατεθεί σε αυτόν τον χρήστη',
        selectStore: 'Επιλέξτε κατάστημα',
        changePlan: 'Αλλαγή πλάνου',
        notes: 'Σημειώσεις',
        roleDefaults: 'Προεπιλογές Ρόλων',
        roleDefaultsTitle: 'Προεπιλεγμένα Δικαιώματα ανά Ρόλο',
        roleDefaultsDescription: 'Ρυθμίστε ποια δικαιώματα θα λαμβάνει κάθε ρόλος εξ ορισμού κατά την ανάθεση σε κατάστημα. Οι αλλαγές επηρεάζουν μόνο νέες αναθέσεις -- τα υπάρχοντα δικαιώματα δεν αλλάζουν.',
        roleDefaultsSaved: 'Οι προεπιλογές ρόλων αποθηκεύτηκαν',
        roleDefaultsReset: 'Επαναφορά προεπιλογών',
        roleDefaultsResetConfirm: 'Επαναφορά όλων των προεπιλογών στις ενσωματωμένες τιμές;',
        roleDefaultsNoChanges: 'Δεν υπάρχουν αλλαγές',
    },
    adminSettings: {
        aiEnabled: 'AI Ενεργοποιημένο',
        aiEnabledDesc: 'Γενική ενεργοποίηση AI λειτουργιών',
        aiModel: 'Μοντέλο AI',
        aiModelDesc: 'Προεπιλεγμένο μοντέλο Claude',
        aiMaxTokens: 'Μέγιστα Tokens AI',
        aiMaxTokensDesc: 'Μέγιστα tokens ανά αίτημα AI',
        maintenance: 'Λειτουργία Συντήρησης',
        maintenanceDesc: 'Ενεργοποίηση λειτουργίας συντήρησης',
        versionIos: 'Έκδοση iOS',
        versionIosDesc: 'Τρέχουσα έκδοση iOS εφαρμογής',
        versionPanel: 'Έκδοση Panel',
        versionPanelDesc: 'Τρέχουσα έκδοση panel',
        bridgeVersion: 'Ελάχιστη Έκδοση Bridge',
        bridgeVersionDesc: 'Ελάχιστη απαιτούμενη έκδοση bridge plugin',
        cacheDashboard: 'Cache Dashboard (δευτ.)',
        cacheDashboardDesc: 'Χρόνος cache dashboard σε δευτερόλεπτα',
        cacheOrders: 'Cache Παραγγελιών (δευτ.)',
        cacheOrdersDesc: 'Χρόνος cache παραγγελιών σε δευτερόλεπτα',
        cacheProducts: 'Cache Προϊόντων (δευτ.)',
        cacheProductsDesc: 'Χρόνος cache προϊόντων σε δευτερόλεπτα',
        graceDays: 'Ημέρες Χάριτος',
        graceDaysDesc: 'Ημέρες μετά τη λήξη πριν απενεργοποίηση',
        notifyDays: 'Ημέρες Ειδοποίησης',
        notifyDaysDesc: 'Ημέρες πριν τη λήξη για ειδοποίηση',
        apiDocsTitle: 'Τεκμηρίωση API',
        apiDocsDesc: 'Ανοίγει σε νέα καρτέλα',
    },
    auditLog: {
        auth: { login: 'Σύνδεση', logout: 'Αποσύνδεση', password_changed: 'Αλλαγή κωδικού' },
        user: { created: 'Δημιουργία χρήστη', updated: 'Ενημέρωση χρήστη', status_changed: 'Αλλαγή κατάστασης' },
        site: { connected: 'Σύνδεση καταστήματος', disconnected: 'Αποσύνδεση καταστήματος' },
        order: { status_changed: 'Αλλαγή κατάστασης παραγγελίας', note_added: 'Προσθήκη σημείωσης', refund_created: 'Επιστροφή χρημάτων' },
        product: { updated: 'Ενημέρωση προϊόντος' },
        settings: { updated: 'Ενημέρωση ρυθμίσεων' },
        subscription: { updated: 'Ενημέρωση συνδρομής', extended: 'Παράταση συνδρομής' },
        permission: { assigned: 'Ανάθεση δικαιωμάτων' },
    },
    roles: {
        super_admin: 'Υπερδιαχειριστής',
        admin: 'Διαχειριστής',
        user: 'Χρήστης',
        store_owner: 'Ιδιοκτήτης',
        manager: 'Διαχειριστής καταστήματος',
        staff: 'Προσωπικό',
    },
    permissions: {
        ordersView: 'Προβολή παραγγελιών',
        ordersEdit: 'Επεξεργασία παραγγελιών',
        ordersRefund: 'Επιστροφή παραγγελιών',
        productsView: 'Προβολή προϊόντων',
        productsEdit: 'Επεξεργασία προϊόντων',
        customersView: 'Προβολή πελατών',
        analyticsView: 'Προβολή αναλυτικών',
        analyticsAdvanced: 'Προχωρημένα αναλυτικά',
        notificationsEnabled: 'Ειδοποιήσεις',
        settingsView: 'Προβολή ρυθμίσεων',
        settingsEdit: 'Επεξεργασία ρυθμίσεων',
        aiChat: 'AI Συνομιλία',
    },
    marketing: {
        title: 'Μάρκετινγκ',
        test: 'Δοκιμή',
        compose: 'Σύνθεση',
        templates: 'Πρότυπα',
        history: 'Ιστορικό',
        queue: 'Ουρά',
        testSend: 'Δοκιμαστική Αποστολή',
        recipient: 'Παραλήπτης',
        channels: 'Κανάλια',
        push: 'Push Ειδοποίηση',
        email: 'Email',
        panelNotification: 'Ειδοποίηση Panel',
        allChannels: 'Όλα τα κανάλια',
        messageTitle: 'Τίτλος',
        messageBody: 'Μήνυμα',
        deepLink: 'Deep Link',
        deepLinkNone: 'Κανένα',
        deepLinkDashboard: 'Πίνακας',
        deepLinkOrder: 'Παραγγελία',
        deepLinkUrl: 'Εξωτερικό URL',
        sendTest: 'Αποστολή Δοκιμαστικού',
        testHistory: 'Ιστορικό Δοκιμών',
        result: 'Αποτέλεσμα',
        delivered: 'Παραδόθηκε',
        sent: 'Στάλθηκε',
        failed: 'Απέτυχε',
        pending: 'Σε αναμονή',
        sending: 'Αποστέλλεται',
        cancelled: 'Ακυρώθηκε',
        draft: 'Πρόχειρο',
        newCampaign: 'Νέα Καμπάνια',
        template: 'Πρότυπο',
        noTemplate: 'Κανένα πρότυπο',
        recipients: 'Παραλήπτες',
        allActiveUsers: 'Όλοι οι ενεργοί χρήστες',
        byRole: 'Ανά ρόλο',
        specificUsers: 'Συγκεκριμένοι χρήστες',
        sendNow: 'Αποστολή τώρα',
        scheduleFor: 'Προγραμματισμός για',
        scheduled: 'Προγραμματισμένο',
        preview: 'Προεπισκόπηση',
        testToMe: 'Δοκιμή σε εμένα',
        sendOrSchedule: 'Αποστολή / Προγραμματισμός',
        newTemplate: 'Νέο Πρότυπο',
        templateName: 'Όνομα πρότυπου',
        templateCategory: 'Κατηγορία',
        variables: 'Μεταβλητές',
        systemTemplate: 'Πρότυπο συστήματος',
        customTemplate: 'Προσαρμοσμένο',
        welcome: 'Καλωσόρισμα',
        reminder: 'Υπενθύμιση',
        summary: 'Αναφορά',
        promo: 'Προωθητικό',
        alert: 'Ειδοποίηση',
        custom: 'Προσαρμοσμένο',
        exportCsv: 'Εξαγωγή CSV',
        campaignDetail: 'Λεπτομέρειες καμπάνιας',
        recipientResults: 'Αποτελέσματα ανά παραλήπτη',
        scheduledMessages: 'Προγραμματισμένα μηνύματα',
        edit: 'Επεξεργασία',
        cancel: 'Ακύρωση',
        sendImmediately: 'Αποστολή τώρα',
        confirmCancel: 'Ακύρωση προγραμματισμένου μηνύματος;',
        confirmSendNow: 'Αποστολή αυτού του μηνύματος τώρα;',
        confirmDelete: 'Διαγραφή αυτού του πρότυπου;',
        hasPushToken: 'Έχει Push Token',
        noPushToken: 'Χωρίς Push Token',
        usersWithTokens: '{{count}} χρήστες με push token',
        totalRecipients: 'Σύνολο παραληπτών',
        deliveredCount: 'Παραδόθηκαν',
        failedCount: 'Απέτυχαν',
        openedCount: 'Ανοίχτηκαν',
        noTestHistory: 'Δεν έχουν σταλεί δοκιμαστικές ειδοποιήσεις',
        noCampaigns: 'Δεν υπάρχουν καμπάνιες',
        noTemplates: 'Δεν υπάρχουν πρότυπα',
        noScheduled: 'Δεν υπάρχουν προγραμματισμένα μηνύματα',
        selectUser: 'Επιλογή χρήστη',
        selectRole: 'Επιλογή ρόλου',
        selectUsers: 'Επιλογή χρηστών',
        campaignSent: 'Η καμπάνια στάλθηκε επιτυχώς',
        testSentSuccess: 'Η δοκιμαστική ειδοποίηση στάλθηκε',
        templateCreated: 'Το πρότυπο δημιουργήθηκε',
        templateUpdated: 'Το πρότυπο ενημερώθηκε',
        templateDeleted: 'Το πρότυπο διαγράφηκε',
        campaignCancelled: 'Η καμπάνια ακυρώθηκε',
        date: 'Ημερομηνία',
        status: 'Κατάσταση',
        actions: 'Ενέργειες',
        viewDetails: 'Λεπτομέρειες',
        back: 'Πίσω',
        close: 'Κλείσιμο',
        save: 'Αποθήκευση',
        create: 'Δημιουργία',
        smtpNotConfigured: 'Δεν έχει ρυθμιστεί SMTP',
        selectTemplate: 'Επιλογή πρότυπου',
        noActiveTokens: 'Χωρίς ενεργά push tokens',
    },
    apiKeys: {
        title: 'API Keys',
        create: 'Δημιουργία API Key',
        name: 'Όνομα κλειδιού',
        scopes: 'Δικαιώματα',
        prefix: 'Πρόθεμα κλειδιού',
        lastUsed: 'Τελευταία χρήση',
        expires: 'Λήγει',
        never: 'Ποτέ',
        neverUsed: 'Δεν χρησιμοποιήθηκε',
        active: 'Ενεργό',
        revoked: 'Ανακλήθηκε',
        revoke: 'Ανάκληση',
        copyWarning: 'Αντιγράψτε αυτό το κλειδί τώρα. Δεν θα εμφανιστεί ξανά.',
        noKeys: 'Δεν υπάρχουν API keys',
        created: 'Το API key δημιουργήθηκε',
        updated: 'Το API key ενημερώθηκε',
        deleted: 'Το API key ανακλήθηκε',
        scopeReadOrders: 'Ανάγνωση παραγγελιών',
        scopeWriteOrders: 'Εγγραφή παραγγελιών',
        scopeReadProducts: 'Ανάγνωση προϊόντων',
        scopeWriteProducts: 'Εγγραφή προϊόντων',
        scopeReadCustomers: 'Ανάγνωση πελατών',
        scopeReadAnalytics: 'Ανάγνωση αναλυτικών',
        scopeReadDashboard: 'Ανάγνωση πίνακα',
        scopeReadNotifications: 'Ανάγνωση ειδοποιήσεων',
        scopeWriteNotifications: 'Εγγραφή ειδοποιήσεων',
        allScopes: 'Πλήρης πρόσβαση',
        site: 'Συνδεδεμένο κατάστημα',
        allSites: 'Όλα τα καταστήματα',
    },
    webhooks: {
        title: 'Webhooks',
        endpoints: 'Endpoints',
        create: 'Δημιουργία Endpoint',
        url: 'URL προορισμού',
        events: 'Γεγονότα',
        secret: 'Κλειδί υπογραφής',
        description: 'Περιγραφή',
        headers: 'Προσαρμοσμένα headers',
        active: 'Ενεργό',
        disabled: 'Απενεργοποιημένο',
        failCount: 'Διαδοχικές αποτυχίες',
        disabledAt: 'Αυτόματη απενεργοποίηση',
        reactivate: 'Επανενεργοποίηση',
        testEvent: 'Αποστολή δοκιμαστικού',
        deliveries: 'Πρόσφατες αποστολές',
        noEndpoints: 'Δεν υπάρχουν webhook endpoints',
        noDeliveries: 'Δεν υπάρχουν αποστολές',
        created: 'Το webhook endpoint δημιουργήθηκε',
        updated: 'Το webhook endpoint ενημερώθηκε',
        deleted: 'Το webhook endpoint διαγράφηκε',
        reactivated: 'Το webhook endpoint επανενεργοποιήθηκε',
        testSent: 'Το δοκιμαστικό στάλθηκε',
        eventNewOrder: 'Νέα παραγγελία',
        eventStatusChanged: 'Αλλαγή κατάστασης',
        eventLowStock: 'Χαμηλό απόθεμα',
        eventRefundCreated: 'Επιστροφή χρημάτων',
        eventBackorder: 'Σε αναμονή',
        eventSubExpiring: 'Συνδρομή λήγει',
        eventSubExpired: 'Συνδρομή έληξε',
        eventBridgeOffline: 'Bridge εκτός σύνδεσης',
        attempt: 'Απόπειρα',
        statusCode: 'Κωδικός κατάστασης',
        duration: 'Διάρκεια',
        site: 'Συνδεδεμένο κατάστημα',
        allSites: 'Όλα τα καταστήματα',
    },
};
//# sourceMappingURL=el.js.map